// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,json_types=true"
// @generated from file forms/v1/forms.proto (package forms.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { VersionIncrement, VersionIncrementJson } from "../../asset/v1/asset_pb";
import { file_asset_v1_asset } from "../../asset/v1/asset_pb";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import type { PaginationArguments, PaginationArgumentsJson, PaginationPageInfo, PaginationPageInfoJson } from "../../common/v1/pagination_pb";
import { file_common_v1_pagination } from "../../common/v1/pagination_pb";
import type { Creator, CreatorJson } from "../../common/v1/types_pb";
import { file_common_v1_types } from "../../common/v1/types_pb";
import type { Field, FieldJson } from "./field_pb";
import { file_forms_v1_field } from "./field_pb";
import type {
	BatchDeleteSubmissionRequestSchema,
	BatchDeleteSubmissionResponseSchema,
	BatchGetSubmissionSummariesRequestSchema,
	BatchGetSubmissionSummariesResponseSchema,
	DeleteSubmissionRequestSchema,
	DeleteSubmissionResponseSchema,
	DownloadSubmissionsCSVRequestSchema,
	GetLiveResultsRequestSchema,
	GetLiveResultsResponseSchema,
	ListSubmissionsRequestSchema,
	ListSubmissionsResponseSchema,
	SubmissionsSummaryRequestSchema,
	SubmissionsSummaryResponseSchema,
	SubmitFormRequestSchema,
	SubmitFormResponseSchema,
} from "./form_submission_pb";
import { file_forms_v1_form_submission } from "./form_submission_pb";
import type { PaginationOptions, PaginationOptionsJson } from "./options_pb";
import { file_forms_v1_options } from "./options_pb";
import type { SuccessAction, SuccessActionJson } from "./success_screen_pb";
import { file_forms_v1_success_screen } from "./success_screen_pb";
import { file_google_api_annotations } from "../../google/api/annotations_pb";
import type { HttpBodySchema } from "../../google/api/httpbody_pb";
import { file_google_api_httpbody } from "../../google/api/httpbody_pb";
import type { FieldMask, FieldMaskJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file forms/v1/forms.proto.
 */
export const file_forms_v1_forms: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_asset_v1_asset, file_common_v1_annotations, file_common_v1_pagination, file_common_v1_types, file_forms_v1_field, file_forms_v1_form_submission, file_forms_v1_options, file_forms_v1_success_screen, file_google_api_annotations, file_google_api_httpbody, file_google_protobuf_field_mask, file_google_protobuf_timestamp],
	);

/**
 * @generated from message forms.v1.Form
 */
export type Form = Message<"forms.v1.Form"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 11;
	 */
	version: string;

	/**
	 * @generated from field: string org_id = 12;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 13;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string folder_path = 14;
	 */
	folderPath: string;

	/**
	 * @generated from field: string state = 15;
	 */
	state: string;

	/**
	 * @generated from field: bool active = 2;
	 */
	active: boolean;

	/**
	 * @generated from field: common.v1.Creator creator = 17;
	 */
	creator?: Creator | undefined;

	/**
	 * @generated from field: forms.v1.SuccessAction success_action = 3;
	 */
	successAction?: SuccessAction | undefined;

	/**
	 * @generated from field: repeated forms.v1.Field fields = 4;
	 */
	fields: Field[];

	/**
	 * @generated from field: string title = 5;
	 */
	title: string;

	/**
	 * @generated from field: string description = 6;
	 */
	description: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 7;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 8;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * @generated from field: optional string action_text = 9;
	 */
	actionText?: string | undefined;

	/**
	 * @generated from field: repeated forms.v1.Rule rules = 10;
	 */
	rules: Rule[];

	/**
	 * @generated from field: repeated string tags = 16;
	 */
	tags: string[];
};

/**
 * @generated from message forms.v1.Form
 */
export type FormJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 11;
	 */
	version?: string;

	/**
	 * @generated from field: string org_id = 12;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 13;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string folder_path = 14;
	 */
	folderPath?: string;

	/**
	 * @generated from field: string state = 15;
	 */
	state?: string;

	/**
	 * @generated from field: bool active = 2;
	 */
	active?: boolean;

	/**
	 * @generated from field: common.v1.Creator creator = 17;
	 */
	creator?: CreatorJson;

	/**
	 * @generated from field: forms.v1.SuccessAction success_action = 3;
	 */
	successAction?: SuccessActionJson;

	/**
	 * @generated from field: repeated forms.v1.Field fields = 4;
	 */
	fields?: FieldJson[];

	/**
	 * @generated from field: string title = 5;
	 */
	title?: string;

	/**
	 * @generated from field: string description = 6;
	 */
	description?: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 7;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 8;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: optional string action_text = 9;
	 */
	actionText?: string;

	/**
	 * @generated from field: repeated forms.v1.Rule rules = 10;
	 */
	rules?: RuleJson[];

	/**
	 * @generated from field: repeated string tags = 16;
	 */
	tags?: string[];
};

/**
 * Describes the message forms.v1.Form.
 * Use `create(FormSchema)` to create a new message.
 */
export const FormSchema: GenMessage<Form, { jsonType: FormJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_forms, 0);

/**
 * @generated from message forms.v1.CreateFormResponse
 */
export type CreateFormResponse = Message<"forms.v1.CreateFormResponse"> & {
	/**
	 * @generated from field: forms.v1.Form form = 1;
	 */
	form?: Form | undefined;
};

/**
 * @generated from message forms.v1.CreateFormResponse
 */
export type CreateFormResponseJson = {
	/**
	 * @generated from field: forms.v1.Form form = 1;
	 */
	form?: FormJson;
};

/**
 * Describes the message forms.v1.CreateFormResponse.
 * Use `create(CreateFormResponseSchema)` to create a new message.
 */
export const CreateFormResponseSchema: GenMessage<CreateFormResponse, { jsonType: CreateFormResponseJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_forms, 1);

/**
 * @generated from message forms.v1.CreateFormRequest
 */
export type CreateFormRequest = Message<"forms.v1.CreateFormRequest"> & {
	/**
	 * @generated from field: string org_id = 8;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 9;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string folder_path = 10;
	 */
	folderPath: string;

	/**
	 * @generated from field: forms.v1.SuccessAction success_action = 1;
	 */
	successAction?: SuccessAction | undefined;

	/**
	 * @generated from field: repeated forms.v1.Field fields = 2;
	 */
	fields: Field[];

	/**
	 * @generated from field: string title = 3;
	 */
	title: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description: string;

	/**
	 * @generated from field: bool active = 5;
	 */
	active: boolean;

	/**
	 * @generated from field: optional string action_text = 6;
	 */
	actionText?: string | undefined;

	/**
	 * @generated from field: repeated forms.v1.Rule rules = 7;
	 */
	rules: Rule[];

	/**
	 * @generated from field: repeated string tags = 11;
	 */
	tags: string[];
};

/**
 * @generated from message forms.v1.CreateFormRequest
 */
export type CreateFormRequestJson = {
	/**
	 * @generated from field: string org_id = 8;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 9;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string folder_path = 10;
	 */
	folderPath?: string;

	/**
	 * @generated from field: forms.v1.SuccessAction success_action = 1;
	 */
	successAction?: SuccessActionJson;

	/**
	 * @generated from field: repeated forms.v1.Field fields = 2;
	 */
	fields?: FieldJson[];

	/**
	 * @generated from field: string title = 3;
	 */
	title?: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description?: string;

	/**
	 * @generated from field: bool active = 5;
	 */
	active?: boolean;

	/**
	 * @generated from field: optional string action_text = 6;
	 */
	actionText?: string;

	/**
	 * @generated from field: repeated forms.v1.Rule rules = 7;
	 */
	rules?: RuleJson[];

	/**
	 * @generated from field: repeated string tags = 11;
	 */
	tags?: string[];
};

/**
 * Describes the message forms.v1.CreateFormRequest.
 * Use `create(CreateFormRequestSchema)` to create a new message.
 */
export const CreateFormRequestSchema: GenMessage<CreateFormRequest, { jsonType: CreateFormRequestJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_forms, 2);

/**
 * @generated from message forms.v1.Rule
 */
export type Rule = Message<"forms.v1.Rule"> & {
	/**
	 * @generated from field: string id = 3;
	 */
	id: string;

	/**
	 * @generated from field: repeated string field_keys = 1;
	 */
	fieldKeys: string[];

	/**
	 * JSON Schema which if evaluates to false given the current form state hides the form element
	 *
	 * @generated from field: string schema = 2;
	 */
	schema: string;
};

/**
 * @generated from message forms.v1.Rule
 */
export type RuleJson = {
	/**
	 * @generated from field: string id = 3;
	 */
	id?: string;

	/**
	 * @generated from field: repeated string field_keys = 1;
	 */
	fieldKeys?: string[];

	/**
	 * JSON Schema which if evaluates to false given the current form state hides the form element
	 *
	 * @generated from field: string schema = 2;
	 */
	schema?: string;
};

/**
 * Describes the message forms.v1.Rule.
 * Use `create(RuleSchema)` to create a new message.
 */
export const RuleSchema: GenMessage<Rule, { jsonType: RuleJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_forms, 3);

/**
 * @generated from message forms.v1.GetFormRequest
 */
export type GetFormRequest = Message<"forms.v1.GetFormRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;
};

/**
 * @generated from message forms.v1.GetFormRequest
 */
export type GetFormRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;
};

/**
 * Describes the message forms.v1.GetFormRequest.
 * Use `create(GetFormRequestSchema)` to create a new message.
 */
export const GetFormRequestSchema: GenMessage<GetFormRequest, { jsonType: GetFormRequestJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_forms, 4);

/**
 * @generated from message forms.v1.GetFormResponse
 */
export type GetFormResponse = Message<"forms.v1.GetFormResponse"> & {
	/**
	 * @generated from field: forms.v1.Form form = 1;
	 */
	form?: Form | undefined;
};

/**
 * @generated from message forms.v1.GetFormResponse
 */
export type GetFormResponseJson = {
	/**
	 * @generated from field: forms.v1.Form form = 1;
	 */
	form?: FormJson;
};

/**
 * Describes the message forms.v1.GetFormResponse.
 * Use `create(GetFormResponseSchema)` to create a new message.
 */
export const GetFormResponseSchema: GenMessage<GetFormResponse, { jsonType: GetFormResponseJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_forms, 5);

/**
 * @generated from message forms.v1.RenderFormRequest
 */
export type RenderFormRequest = Message<"forms.v1.RenderFormRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message forms.v1.RenderFormRequest
 */
export type RenderFormRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message forms.v1.RenderFormRequest.
 * Use `create(RenderFormRequestSchema)` to create a new message.
 */
export const RenderFormRequestSchema: GenMessage<RenderFormRequest, { jsonType: RenderFormRequestJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_forms, 6);

/**
 * @generated from message forms.v1.RenderFormResponse
 */
export type RenderFormResponse = Message<"forms.v1.RenderFormResponse"> & {
	/**
	 * @generated from field: forms.v1.Form form = 1;
	 */
	form?: Form | undefined;
};

/**
 * @generated from message forms.v1.RenderFormResponse
 */
export type RenderFormResponseJson = {
	/**
	 * @generated from field: forms.v1.Form form = 1;
	 */
	form?: FormJson;
};

/**
 * Describes the message forms.v1.RenderFormResponse.
 * Use `create(RenderFormResponseSchema)` to create a new message.
 */
export const RenderFormResponseSchema: GenMessage<RenderFormResponse, { jsonType: RenderFormResponseJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_forms, 7);

/**
 * Performs a PUT-style update, syncing all form state
 *
 * @generated from message forms.v1.UpdateFormRequest
 */
export type UpdateFormRequest = Message<"forms.v1.UpdateFormRequest"> & {
	/**
	 * @generated from field: forms.v1.Form form = 1;
	 */
	form?: Form | undefined;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask | undefined;
};

/**
 * Performs a PUT-style update, syncing all form state
 *
 * @generated from message forms.v1.UpdateFormRequest
 */
export type UpdateFormRequestJson = {
	/**
	 * @generated from field: forms.v1.Form form = 1;
	 */
	form?: FormJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;
};

/**
 * Describes the message forms.v1.UpdateFormRequest.
 * Use `create(UpdateFormRequestSchema)` to create a new message.
 */
export const UpdateFormRequestSchema: GenMessage<UpdateFormRequest, { jsonType: UpdateFormRequestJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_forms, 8);

/**
 * @generated from message forms.v1.UpdateFormResponse
 */
export type UpdateFormResponse = Message<"forms.v1.UpdateFormResponse"> & {
	/**
	 * @generated from field: forms.v1.Form form = 1;
	 */
	form?: Form | undefined;
};

/**
 * @generated from message forms.v1.UpdateFormResponse
 */
export type UpdateFormResponseJson = {
	/**
	 * @generated from field: forms.v1.Form form = 1;
	 */
	form?: FormJson;
};

/**
 * Describes the message forms.v1.UpdateFormResponse.
 * Use `create(UpdateFormResponseSchema)` to create a new message.
 */
export const UpdateFormResponseSchema: GenMessage<UpdateFormResponse, { jsonType: UpdateFormResponseJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_forms, 9);

/**
 * @generated from message forms.v1.ArchiveFormRequest
 */
export type ArchiveFormRequest = Message<"forms.v1.ArchiveFormRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message forms.v1.ArchiveFormRequest
 */
export type ArchiveFormRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message forms.v1.ArchiveFormRequest.
 * Use `create(ArchiveFormRequestSchema)` to create a new message.
 */
export const ArchiveFormRequestSchema: GenMessage<ArchiveFormRequest, { jsonType: ArchiveFormRequestJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_forms, 10);

/**
 * @generated from message forms.v1.ArchiveFormResponse
 */
export type ArchiveFormResponse = Message<"forms.v1.ArchiveFormResponse"> & {};

/**
 * @generated from message forms.v1.ArchiveFormResponse
 */
export type ArchiveFormResponseJson = {};

/**
 * Describes the message forms.v1.ArchiveFormResponse.
 * Use `create(ArchiveFormResponseSchema)` to create a new message.
 */
export const ArchiveFormResponseSchema: GenMessage<ArchiveFormResponse, { jsonType: ArchiveFormResponseJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_forms, 11);

/**
 * @generated from message forms.v1.ListFormsRequest
 */
export type ListFormsRequest = Message<"forms.v1.ListFormsRequest"> & {
	/**
	 * @generated from field: string org_id = 4;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 5;
	 */
	workspaceId: string;

	/**
	 * @generated from field: optional string folder_path = 6;
	 */
	folderPath?: string | undefined;

	/**
	 * @generated from field: string creator_id = 7;
	 */
	creatorId: string;

	/**
	 * @generated from field: string name_prefix = 8;
	 */
	namePrefix: string;

	/**
	 * @generated from field: repeated string tags = 9;
	 */
	tags: string[];

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 10;
	 */
	pagination?: PaginationArguments | undefined;

	/**
	 * @deprecated: use canonical Pagination instead
	 *
	 * @generated from field: optional forms.v1.PaginationOptions page_options = 3 [deprecated = true];
	 * @deprecated
	 */
	pageOptions?: PaginationOptions | undefined;
};

/**
 * @generated from message forms.v1.ListFormsRequest
 */
export type ListFormsRequestJson = {
	/**
	 * @generated from field: string org_id = 4;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 5;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: optional string folder_path = 6;
	 */
	folderPath?: string;

	/**
	 * @generated from field: string creator_id = 7;
	 */
	creatorId?: string;

	/**
	 * @generated from field: string name_prefix = 8;
	 */
	namePrefix?: string;

	/**
	 * @generated from field: repeated string tags = 9;
	 */
	tags?: string[];

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 10;
	 */
	pagination?: PaginationArgumentsJson;

	/**
	 * @deprecated: use canonical Pagination instead
	 *
	 * @generated from field: optional forms.v1.PaginationOptions page_options = 3 [deprecated = true];
	 * @deprecated
	 */
	pageOptions?: PaginationOptionsJson;
};

/**
 * Describes the message forms.v1.ListFormsRequest.
 * Use `create(ListFormsRequestSchema)` to create a new message.
 */
export const ListFormsRequestSchema: GenMessage<ListFormsRequest, { jsonType: ListFormsRequestJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_forms, 12);

/**
 * @generated from message forms.v1.ListFormsResponse
 */
export type ListFormsResponse = Message<"forms.v1.ListFormsResponse"> & {
	/**
	 * @generated from field: repeated forms.v1.Form forms = 1;
	 */
	forms: Form[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 3;
	 */
	pageInfo?: PaginationPageInfo | undefined;

	/**
	 * @deprecated: use canonical PageInfo instead
	 *
	 * @generated from field: string next_page_token = 2 [deprecated = true];
	 * @deprecated
	 */
	nextPageToken: string;
};

/**
 * @generated from message forms.v1.ListFormsResponse
 */
export type ListFormsResponseJson = {
	/**
	 * @generated from field: repeated forms.v1.Form forms = 1;
	 */
	forms?: FormJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 3;
	 */
	pageInfo?: PaginationPageInfoJson;

	/**
	 * @deprecated: use canonical PageInfo instead
	 *
	 * @generated from field: string next_page_token = 2 [deprecated = true];
	 * @deprecated
	 */
	nextPageToken?: string;
};

/**
 * Describes the message forms.v1.ListFormsResponse.
 * Use `create(ListFormsResponseSchema)` to create a new message.
 */
export const ListFormsResponseSchema: GenMessage<ListFormsResponse, { jsonType: ListFormsResponseJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_forms, 13);

/**
 * @generated from message forms.v1.CreateFormVersionRequest
 */
export type CreateFormVersionRequest = Message<"forms.v1.CreateFormVersionRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2 [deprecated = true];
	 * @deprecated
	 */
	version: string;

	/**
	 * @generated from field: asset.v1.VersionIncrement increment = 4;
	 */
	increment: VersionIncrement;

	/**
	 * @generated from field: string base_version = 3;
	 */
	baseVersion: string;
};

/**
 * @generated from message forms.v1.CreateFormVersionRequest
 */
export type CreateFormVersionRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2 [deprecated = true];
	 * @deprecated
	 */
	version?: string;

	/**
	 * @generated from field: asset.v1.VersionIncrement increment = 4;
	 */
	increment?: VersionIncrementJson;

	/**
	 * @generated from field: string base_version = 3;
	 */
	baseVersion?: string;
};

/**
 * Describes the message forms.v1.CreateFormVersionRequest.
 * Use `create(CreateFormVersionRequestSchema)` to create a new message.
 */
export const CreateFormVersionRequestSchema: GenMessage<CreateFormVersionRequest, { jsonType: CreateFormVersionRequestJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_forms, 14);

/**
 * @generated from message forms.v1.CreateFormVersionResponse
 */
export type CreateFormVersionResponse = Message<"forms.v1.CreateFormVersionResponse"> & {
	/**
	 * @generated from field: forms.v1.Form form = 1;
	 */
	form?: Form | undefined;
};

/**
 * @generated from message forms.v1.CreateFormVersionResponse
 */
export type CreateFormVersionResponseJson = {
	/**
	 * @generated from field: forms.v1.Form form = 1;
	 */
	form?: FormJson;
};

/**
 * Describes the message forms.v1.CreateFormVersionResponse.
 * Use `create(CreateFormVersionResponseSchema)` to create a new message.
 */
export const CreateFormVersionResponseSchema: GenMessage<CreateFormVersionResponse, { jsonType: CreateFormVersionResponseJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_forms, 15);

/**
 * @generated from message forms.v1.PublishFormVersionRequest
 */
export type PublishFormVersionRequest = Message<"forms.v1.PublishFormVersionRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;
};

/**
 * @generated from message forms.v1.PublishFormVersionRequest
 */
export type PublishFormVersionRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;
};

/**
 * Describes the message forms.v1.PublishFormVersionRequest.
 * Use `create(PublishFormVersionRequestSchema)` to create a new message.
 */
export const PublishFormVersionRequestSchema: GenMessage<PublishFormVersionRequest, { jsonType: PublishFormVersionRequestJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_forms, 16);

/**
 * @generated from message forms.v1.PublishFormVersionResponse
 */
export type PublishFormVersionResponse = Message<"forms.v1.PublishFormVersionResponse"> & {
	/**
	 * @generated from field: forms.v1.Form form = 1;
	 */
	form?: Form | undefined;
};

/**
 * @generated from message forms.v1.PublishFormVersionResponse
 */
export type PublishFormVersionResponseJson = {
	/**
	 * @generated from field: forms.v1.Form form = 1;
	 */
	form?: FormJson;
};

/**
 * Describes the message forms.v1.PublishFormVersionResponse.
 * Use `create(PublishFormVersionResponseSchema)` to create a new message.
 */
export const PublishFormVersionResponseSchema: GenMessage<PublishFormVersionResponse, { jsonType: PublishFormVersionResponseJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_forms, 17);

/**
 * @generated from message forms.v1.DeleteFormRequest
 */
export type DeleteFormRequest = Message<"forms.v1.DeleteFormRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;
};

/**
 * @generated from message forms.v1.DeleteFormRequest
 */
export type DeleteFormRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;
};

/**
 * Describes the message forms.v1.DeleteFormRequest.
 * Use `create(DeleteFormRequestSchema)` to create a new message.
 */
export const DeleteFormRequestSchema: GenMessage<DeleteFormRequest, { jsonType: DeleteFormRequestJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_forms, 18);

/**
 * @generated from message forms.v1.DeleteFormResponse
 */
export type DeleteFormResponse = Message<"forms.v1.DeleteFormResponse"> & {};

/**
 * @generated from message forms.v1.DeleteFormResponse
 */
export type DeleteFormResponseJson = {};

/**
 * Describes the message forms.v1.DeleteFormResponse.
 * Use `create(DeleteFormResponseSchema)` to create a new message.
 */
export const DeleteFormResponseSchema: GenMessage<DeleteFormResponse, { jsonType: DeleteFormResponseJson }> = /*@__PURE__*/ messageDesc(file_forms_v1_forms, 19);

/**
 * @generated from service forms.v1.FormsService
 */
export const FormsService: GenService<{
	/**
	 * @generated from rpc forms.v1.FormsService.CreateForm
	 */
	createForm: {
		methodKind: "unary";
		input: typeof CreateFormRequestSchema;
		output: typeof CreateFormResponseSchema;
	};
	/**
	 * @generated from rpc forms.v1.FormsService.CreateFormVersion
	 */
	createFormVersion: {
		methodKind: "unary";
		input: typeof CreateFormVersionRequestSchema;
		output: typeof CreateFormVersionResponseSchema;
	};
	/**
	 * @generated from rpc forms.v1.FormsService.PublishFormVersion
	 */
	publishFormVersion: {
		methodKind: "unary";
		input: typeof PublishFormVersionRequestSchema;
		output: typeof PublishFormVersionResponseSchema;
	};
	/**
	 * @generated from rpc forms.v1.FormsService.GetForm
	 */
	getForm: {
		methodKind: "unary";
		input: typeof GetFormRequestSchema;
		output: typeof GetFormResponseSchema;
	};
	/**
	 * @generated from rpc forms.v1.FormsService.RenderForm
	 */
	renderForm: {
		methodKind: "unary";
		input: typeof RenderFormRequestSchema;
		output: typeof RenderFormResponseSchema;
	};
	/**
	 * @generated from rpc forms.v1.FormsService.UpdateForm
	 */
	updateForm: {
		methodKind: "unary";
		input: typeof UpdateFormRequestSchema;
		output: typeof UpdateFormResponseSchema;
	};
	/**
	 * @generated from rpc forms.v1.FormsService.ArchiveForm
	 */
	archiveForm: {
		methodKind: "unary";
		input: typeof ArchiveFormRequestSchema;
		output: typeof ArchiveFormResponseSchema;
	};
	/**
	 * @generated from rpc forms.v1.FormsService.DeleteForm
	 */
	deleteForm: {
		methodKind: "unary";
		input: typeof DeleteFormRequestSchema;
		output: typeof DeleteFormResponseSchema;
	};
	/**
	 * @generated from rpc forms.v1.FormsService.ListForms
	 */
	listForms: {
		methodKind: "unary";
		input: typeof ListFormsRequestSchema;
		output: typeof ListFormsResponseSchema;
	};
	/**
	 * @generated from rpc forms.v1.FormsService.SubmitForm
	 */
	submitForm: {
		methodKind: "unary";
		input: typeof SubmitFormRequestSchema;
		output: typeof SubmitFormResponseSchema;
	};
	/**
	 * @generated from rpc forms.v1.FormsService.ListSubmissions
	 */
	listSubmissions: {
		methodKind: "unary";
		input: typeof ListSubmissionsRequestSchema;
		output: typeof ListSubmissionsResponseSchema;
	};
	/**
	 * @generated from rpc forms.v1.FormsService.DeleteSubmission
	 */
	deleteSubmission: {
		methodKind: "unary";
		input: typeof DeleteSubmissionRequestSchema;
		output: typeof DeleteSubmissionResponseSchema;
	};
	/**
	 * @generated from rpc forms.v1.FormsService.BatchDeleteSubmission
	 */
	batchDeleteSubmission: {
		methodKind: "unary";
		input: typeof BatchDeleteSubmissionRequestSchema;
		output: typeof BatchDeleteSubmissionResponseSchema;
	};
	/**
	 * @generated from rpc forms.v1.FormsService.SubmissionsSummary
	 */
	submissionsSummary: {
		methodKind: "unary";
		input: typeof SubmissionsSummaryRequestSchema;
		output: typeof SubmissionsSummaryResponseSchema;
	};
	/**
	 * buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
	 *
	 * @generated from rpc forms.v1.FormsService.DownloadSubmissionsCSV
	 */
	downloadSubmissionsCSV: {
		methodKind: "unary";
		input: typeof DownloadSubmissionsCSVRequestSchema;
		output: typeof HttpBodySchema;
	};
	/**
	 * @generated from rpc forms.v1.FormsService.GetLiveResults
	 */
	getLiveResults: {
		methodKind: "server_streaming";
		input: typeof GetLiveResultsRequestSchema;
		output: typeof GetLiveResultsResponseSchema;
	};
	/**
	 * @generated from rpc forms.v1.FormsService.BatchGetSubmissionSummaries
	 */
	batchGetSubmissionSummaries: {
		methodKind: "unary";
		input: typeof BatchGetSubmissionSummariesRequestSchema;
		output: typeof BatchGetSubmissionSummariesResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_forms_v1_forms, 0);
